// Reducer for managing dialog and form state
export const initialState = {
	dialogs: {
		deleteConfirm: false,
		addConfirm: false,
		editConfirm: false,
		modifyRolesConfirm: false,
		selectedRecord: null,
	},
	forms: {
		assignRoleFormData: {
			Roles: [],
		},
		initialRoleFormData: {
			Roles: [],
		},
		addUserForm: {
			firstName: "",
			lastName: "",
			email: "",
			mobileNumber: "",
			IdType: "",
			idNumber: "",
			Roles: [],
		},
		editUserForm: {
			firstName: "",
			lastName: "",
			email: "",
			mobileNumber: "",
			IdType: "",
			idNumber: "",
		},
	},
	ui: {
		roleOptions: [],
	},
	loading: {
		isLoadingBackdrop: false,
		isBackgroundRefreshing: false,
	},
	table: {
		searchInput: "",
		currentPage: 1,
		recordsPerPage: 10,
	},
};

export function manageUsersReducer(state, action) {
	switch (action.type) {
		case "OPEN_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: true,
					selectedRecord: action.payload,
				},
			};
		case "CLOSE_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: false,
					selectedRecord: null,
				},
			};
		case "OPEN_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: true,
					selectedRecord: action.payload.record,
				},
				forms: {
					...state.forms,
					editUserForm: action.payload.editFormData,
					initialEditUserForm: action.payload.editFormData
					
				},
			};
		case "CLOSE_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					editUserForm: initialState.forms.editUserForm
				},
			};
		case "OPEN_ADD_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					addConfirm: true,
				},
				ui: {
					...state.ui,
					roleOptions: action.payload.roleOptions,
				},
			};
		case "CLOSE_ADD_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					addConfirm: false,
				},
				forms: {
					...state.forms,
					addUserForm: {
						firstName: "",
						lastName: "",
						email: "",
						mobileNumber: "",
						IdType: "",
						idNumber: "",
						Roles: [],
					},
				},
			};
		case "OPEN_MODIFY_ROLES_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					modifyRolesConfirm: true,
					selectedRecord: action.payload.record,
				},
				ui: {
					...state.ui,
					roleOptions: action.payload.roleOptions,
				},
				forms: {
					...state.forms,
					assignRoleFormData: {
						Roles: action.payload.initialRoles,
					},
					initialRoleFormData: {
						Roles: action.payload.initialRoles,
					},
				},
			};
		case "CLOSE_MODIFY_ROLES_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					modifyRolesConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					assignRoleFormData: {
						Roles: [],
					},
					initialRoleFormData: {
						Roles: [],
					},
				},
			};
		case "UPDATE_FORM_FIELD":
			//console.log('Reducer UPDATE_FORM_FIELD - Before:', state.forms[action.payload.formName]);
			const updatedState = {
				...state,
				forms: {
					...state.forms,
					[action.payload.formName]: {
						...state.forms[action.payload.formName],
						[action.payload.fieldName]: action.payload.value,
					},
				},
			};
			//console.log('Reducer UPDATE_FORM_FIELD - After:', updatedState.forms[action.payload.formName]);
			return updatedState;
		case "SET_LOADING":
			return {
				...state,
				loading: {
					...state.loading,
					[action.payload.key]: action.payload.value,
				},
			};
		case "SET_SEARCH_INPUT":
			return {
				...state,
				table: { ...state.table, searchInput: action.payload, currentPage: 1 },
			};

		case "SET_CURRENT_PAGE":
			return {
				...state,
				table: { ...state.table, currentPage: action.payload },
			};
		default:
			return state;
	}
}
